<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        placeholder="请输入专题id"
        v-model="params.id"
        clearable
        size="small"
        class="param-input"
      ></el-input>
      <el-input
        placeholder="请输入专题名称"
        v-model="params.sectionName"
        clearable
        size="small"
        class="param-input"
      ></el-input>
      <el-input
        placeholder="请输入亚模块ID"
        v-model="params.subModuleID"
        clearable
        size="small"
        class="param-input"
      ></el-input>
      <el-select
        v-model="params.status"
        placeholder="请选择是否启用"
        clearable
        size="small"
      >
        <el-option
          v-for="item in enables"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getSections('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add')"
        style="margin-right: 20px"
        >新增</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="600"
    >
      <el-table-column
        prop="id"
        label="专题id"
        align="center"
        fixed
        min-width="210"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ initTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="封面" align="center" min-width="120" prop="cover">
        <template slot-scope="scope">
          <img-load
            :width="'80px'"
            :height="'60px'"
            :src="imgUrl + scope.row.sectionCover"
            v-if="scope.row.sectionCover"
          >
          </img-load>
          <span v-else style="color: #838F9B">暂无图片</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="sectionName"
        label="专题名称"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.sectionName || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status === 1">启用</el-tag>
          <el-tag type="danger" v-if="scope.row.status === 0">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="showType"
        label="展示类型"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.showType === 0"
            >一大四小</el-tag
          >
          <el-tag type="success" v-if="scope.row.showType === 1"
            >四宫格(横)</el-tag
          >
          <el-tag type="success" v-if="scope.row.showType === 2"
            >四宫格(竖)</el-tag
          >
          <el-tag type="danger" v-else-if="scope.row.showType === 3"
            >六宫格</el-tag
          >
          <el-tag type="warning" v-else-if="scope.row.showType === 4"
            >横版滑动(小)</el-tag
          >
          <el-tag type="warning" v-else-if="scope.row.showType === 5"
            >横版滑动(大)</el-tag
          >
          <el-tag type="warning" v-else-if="scope.row.showType === 6"
            >竖版滑动(大)</el-tag
          >
          <el-tag type="warning" v-else-if="scope.row.showType === 7"
            >大横屏无限制</el-tag
          >
          <el-tag type="warning" v-else-if="scope.row.showType === 8"
            >大横屏 + 横版滑动(小)</el-tag
          >
          <el-tag type="warning" v-else-if="scope.row.showType === 9"
            >竖排六宫格</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="isMadou"
        label="是否工作室"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.isMadou === true">是</el-tag>
          <el-tag type="danger" v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="officialCert"
        label="是否官方认证"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.officialCert === true"
            >是</el-tag
          >
          <el-tag type="danger" v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="tags" label="标签" align="center" min-width="200">
        <template slot-scope="scope">
          <div v-for="(tag, i) in scope.row.tags" :key="i" class="tagBox">
            <el-tag type="success" size="mini" effect="plain" class="tags">{{
              "#" + tag
            }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="originalUserID"
        label="原创博主ID"
        align="center"
        min-width="210"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.originalUserID || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="portrait"
        label="头像"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.portrait === ''" style="color: #838F9B"
            >暂无图片</span
          >
          <el-image
            v-else
            style="width: 70px; height: 70px"
            :src="imgUrl + scope.row.portrait"
            fit="fill"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        prop="sectionLimit"
        label="专题数量"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.sectionLimit || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="subModuleID"
        label="亚模块ID"
        align="center"
        min-width="210"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.subModuleID || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="subModuleName"
        label="亚模块名称"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.subModuleName || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.sort || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="修改时间"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ initTime(scope.row.updatedAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="deletedAt"
        label="删除时间"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ initTime(scope.row.deletedAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="280"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            icon="el-icon-view"
            @click="watchClickNum(scope.row)"
            >点击量</el-button
          >
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="del(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 新增、修改 -->
    <el-dialog
      class="editDialog"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      @before-close="handleClose"
    >
      <el-form :model="form" label-width="80px" :rules="rules" ref="form">
        <el-form-item label="图片:" prop="cover">
          <base-upload
            class="upload"
            :cover="form.sectionCover"
            :action="action"
            wSize="47"
            hSize="47"
            :width="'138.5px'"
            :height="'138.5px'"
            @successCallback="handleAvatarSuccess"
          ></base-upload>
        </el-form-item>
        <el-form-item label="专题名称" prop="sectionName">
          <el-input style="width: 360px" v-model="form.sectionName"></el-input>
        </el-form-item>
        <el-form-item label="亚模块id" prop="subModuleID">
          <el-input style="width: 360px" v-model="form.subModuleID"></el-input>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-select
            style="width: 360px"
            v-model="form.status"
            placeholder="请选择是否启用"
          >
            <el-option
              v-for="item in enables"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="展示方式">
          <el-select
            style="width: 360px"
            v-model="form.showType"
            clearable
            placeholder="请选择展示方式"
          >
            <el-option
              v-for="item in showTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input style="width: 360px" v-model.number="form.sort"></el-input>
        </el-form-item>
        <el-form-item label="标签:" prop="tags">
          <tag-selector v-model="form.tags" :tagList="tagList" :tagLimit="9"></tag-selector>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="onSubmit()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="点击量"
      :visible.sync="isClickNum"
      class="clickNumDialog"
      :close="close"
    >
      <!-- <el-date-picker v-model="clickNumTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small" @change="changeTime"></el-date-picker> -->
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="queryClickNum()"
        >搜索</el-button
      >
      <el-table
        :data="clickNumList"
        max-height="600"
        border
        style="width: 100%; margin-top: 20px;"
        v-loading="clickLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column
          prop="date"
          label="日期"
          min-width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="sectionID"
          label="专题ID"
          min-width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="hitsPerDay"
          label="点击量"
          min-width="180"
          align="center"
        ></el-table-column>
      </el-table>
      <el-pagination
        :page-sizes="[10, 15, 20, 30]"
        :current-page="clickNumParams.pageNumber"
        :page-size="clickNumParams.pageSize"
        layout=" sizes, prev, pager, next, jumper"
        :total="clickNumParams.total"
        background
        @size-change="changeDialogSize"
        @current-change="changeDialogCurrent"
      ></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
import { changeTime } from "@/utils/global";
import { validatorIndex, uniteDate } from "@/utils/validator.js";
import baseConfig from "@/utils/serverUrlConfig";
import TagSelector from "@/components/tagSelector";

export default {
  components: {
    TagSelector,
  },
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      imgUrl: baseConfig.imgUrl,
      enables: [
        { label: "启用", value: 1 },
        { label: "禁用", value: 0 },
      ],
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      // 列表数据
      tableData: [],
      tagList: [], //标签列表：包含标签名称和标签id
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 30,
        sort: [
          {
            sortKey: "sort",
            sortVal: 1,
          },
        ],
      },
      form: {
        sectionName: "",
        sectionCover: "",
        subModuleID: undefined,
        status: 1,
        sort: undefined,
        showType: undefined,
        tags: [],
      },
      showTypes: [
        { value: 0, label: "一大四小" },
        { value: 1, label: "四宫格(横)" },
        { value: 2, label: "四宫格(竖)" },
        { value: 3, label: "六宫格" },
        { value: 4, label: "横版滑动(小)" },
        { value: 5, label: "横版滑动(大)" },
        { value: 6, label: "竖版滑动(大)" },
        { value: 7, label: "大横屏无限制" },
        { value: 8, label: "大横屏 + 横版滑动(小)" },
        { value: 9, label: "竖排六宫格" },
      ],
      dialogVisible: false,
      dialogTitle: "",
      rules: {
        sectionName: [
          { required: true, message: "请输入专题名称", trigger: "blur" },
        ],
        subModuleID: [
          { required: true, message: "请输入亚模块id", trigger: "blur" },
        ],
        sort: [{ validator: validatorIndex, trigger: "blur" }],
      },
      isClickNum: false,
      clickNumTime: "",
      clickNumParams: {
        pageNumber: 1,
        pageSize: 10,
        sectionID: "",
        // total: 0,
        start: "",
        end: "",
      },
      clickNumList: [],
      clickLoading: false,
    };
  },
  created() {
    this.getSections();
  },
  methods: {
    // 请求列表
    getSections(type) {
      this.loading = false;
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getSections(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getTagList() {
      const params = {};
      API.queryTagList(params).then((res) => {
        if (res.code === 200) {
          this.tagList = res.data.list;
        }
      });
    },
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
      this.form.sectionCover = res.data.coverImg;
    },
    // 新增专题配置
    addAndEdit(param) {
      this.getTagList();
      this.dialogVisible = true; // 打开新增、编辑对话框
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        this.form.id = param.id;
        this.form.sectionName = param.sectionName;
        this.form.sectionCover = param.sectionCover;
        this.form.status = param.status;
        this.form.subModuleID = param.subModuleID;
        this.form.sort = param.sort;
        this.form.tags = param.tags || [];
      }
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const tags = this.form.tags.filter(
            (item) => this.tagList.map((e) => e.name).indexOf(item) === -1
          );
          if (tags.length > 0) {
            this.$confirm(
              `标签${tags.join(",")}不属于常用标签，确定新增？`,
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(() => {
                this.addOption();
              })
              .catch(() => {
                this.flag = false;
                return false;
              });
          } else {
            this.addOption();
          }
        } else {
          return false;
        }
      });
    },
    addOption() {
      const addData = {
        sectionName: this.form.sectionName,
        subModuleID: this.form.subModuleID,
        status: this.form.status,
        sort: this.form.sort,
        showType: this.form.showType,
        tags: this.form.tags.length > 0 ? this.form.tags : undefined,
        sectionCover: this.form.sectionCover,
      };
      API.addSection(addData).then((res) => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "新增成功",
          });
          this.dialogVisible = false;
          this.getSections();
        } else {
          this.$message({
            type: "error",
            message: res.tip || res.msg || "新增失败",
          });
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const tags = this.form.tags.filter(
            (item) => this.tagList.map((e) => e.name).indexOf(item) === -1
          );
          if (tags.length > 0) {
            this.$confirm(
              `标签${tags.join(",")}不属于常用标签，确定修改？`,
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(() => {
                this.editOption();
              })
              .catch(() => {
                this.flag = false;
                return false;
              });
          } else {
            this.editOption();
          }
        } else {
          return false;
        }
      });
    },
    editOption() {
      API.editSection(this.form).then((res) => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "编辑成功",
          });
          this.dialogVisible = false;
          this.getSections();
        } else {
          this.$message({
            type: "error",
            message: res.tip || res.msg || "编辑失败",
          });
        }
      });
    },
    // 删除方法
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color: blue'>${param.sectionName}</span>, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: param.id,
          };
          API.deleteSection(delData)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message({
                  type: "success",
                  message: "删除失败!",
                });
              }
              this.getSections();
            })
            .catch(() => {
              this.$message({
                type: "error",
                message: "服务器异常!",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 打开点击量弹窗
    watchClickNum(row) {
      this.clickNumParams.sectionID = row.id;
      this.queryClickNum();
      this.isClickNum = true;
    },
    // 查询点击量
    queryClickNum() {
      let req = {
        pageNumber: this.clickNumParams.pageNumber,
        pageSize: this.clickNumParams.pageSize,
        sectionID: this.clickNumParams.sectionID,
      };
      this.clickLoading = true;
      API.queryClicks(req)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.clickNumList = res.data.List ? res.data.List : [];
          } else {
            this.clickNumList = [];
          }
          this.clickLoading = false;
        })
        .catch(() => {
          this.clickLoading = false;
        });
    },
    // 关闭点击量弹窗
    close() {
      this.clickNumTime = "";
      this.clickNumParams.pageNumber = 1;
      this.clickNumParams.pageSize = 10;
      this.clickNumParams.sectionID = "";
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.sectionCover = "";
      this.form.sectionName = "";
      this.form.subModuleID = undefined;
      this.form.status = 1;
      this.form.sort = undefined;
      this.dialogVisible = false;
      this.form.showType = undefined;
      this.form.tags = [];
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getSections();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getSections();
    },
    // 分页条数改变回调
    changeDialogSize(size) {
      this.clickNumParams.pageSize = size;
      this.queryClickNum();
    },
    // 分页页码改变回调
    changeDialogCurrent(pageNumber) {
      this.clickNumParams.pageNumber = pageNumber;
      this.queryClickNum();
    },
    // 更换时间格式
    initTime(time) {
      return uniteDate(time);
    },
    // 时间变化
    changeTime(time) {
      if (time) {
        this.clickNumParams.start = changeTime(time[0]);
        this.clickNumParams.end = changeTime(time[1]);
      } else {
        this.clickNumParams.start = "";
        this.clickNumParams.end = "";
      }
      this.queryClickNum();
    },
  },
};
</script>

<style lang="scss" scoped>
.editDialog {
  .el-form-item {
    display: flex;
    .el-form-item__content {
      width: 200px;
    }
  }
}

.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
.clickNumDialog {
  /deep/ .el-dialog__body {
    padding-top: 10px;
  }
  /deep/ .el-pagination {
    float: none;
    text-align: right;
    margin-top: 30px;
  }
}
</style>
